module.exports = __webpack_public_path__ + "static/acquaint-fate-icon-b9de33dd70361147f8df451566057169.png";